import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import axios from "axios";
import { baseUrl } from "../../shared/baseUrl";
import { states, lgas, propertyTypes } from '../../data/PropertyData';
import { NewLGA } from '../../data/NewLGA';
import Swal from 'sweetalert2';

const Request = () => {

  // --- Property States --- //
  const [budget, setBudget] = useState("")
  const [state, setState] = useState("")
  const [lga, setLga] = useState("")
  const [newLga, setNewLga] = useState([])
  const [category, setCategory] = useState("")
  const [propertyType, setPropertyType] = useState("")
  const [beds, setBeds] = useState("")
  const [comments, setComments] = useState("")
  const [fullname, setFullname] = useState("")
  const [email, setEmail] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    document.title = "Request for Property - Island Luxury"
    NewLGA({state, lgas, setNewLga })
  }, [state])

  const handlePostRequest = (e) => {
    e.preventDefault()
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const postRequest = async () => {
      try {
        setLoading(true)
        await axios.post(baseUrl + "/api/v1/requests", {
          budget,
          state,
          lga,
          category,
          propertyType,
          beds,
          comments,
          fullname,
          email,
          phoneNumber
        }, config)
        Swal.fire({
          icon: 'success',
          title: 'Posted',
          text: "Your property request have been saved!"
        })
        setBudget("")
        setState("")
        setLga("")
        setCategory("")
        setPropertyType("")
        setBeds("")
        setComments("")
        setFullname("")
        setEmail("")
        setPhoneNumber("")
        setLoading(false)
      }
      catch(err){
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${err.response && err.response.data.message ? err.response.data.message : err.message}`
        })
        setLoading(false)
      }
    }
    postRequest()
  }


  return (
    <div id="request">
      <Header />
      <main>
        <section className="intro-area">
          <div className="intro-area_wrap center container">
            <h1>Request for a property</h1>
          </div>
        </section>
        <section className="request-form container">
          <form onSubmit={handlePostRequest}>
            <div className="form-grp">
              <label htmlFor="category">Category</label>
              <select id="category" value={category} onChange={(e) => setCategory(e.target.value)} required>
                <option value="All Categories">All Categories</option>
                <option value="For Rent">For Rent</option>
                <option value="For Sale">For Sale</option>
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="property-type">Property Type</label>
              <select id="property-type" value={propertyType} onChange={(e) => setPropertyType(e.target.value)} required>
              {propertyTypes.map((item, index) => 
                <option key={index} value={item}>{item}</option>
              )}  
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="state">State</label>
              <select id="state" value={state} onChange={(e) => setState(e.target.value)} required>
              {states.map((item, index) => 
                <option key={index} value={item}>{item}</option>
              )}
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="lga">L.G.A</label>
              <select id="lga" value={lga} onChange={(e) => setLga(e.target.value)} required>
                <option>Select L.G.A</option>
                {state && 
                  newLga.map((item, index) => 
                    <option key={index} value={item}>{item}</option>
                  )
                }
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="beds">Bedroom (optional)</label>
              <input type="number" id="beds" min="1" max="15" value={beds} onChange={(e) => setBeds(e.target.value)} required />
            </div>
            <div className="form-grp">
              <label htmlFor="budget">Budget</label>
              <input type="number" id="budget" placeholder="₦" required value={budget} onChange={(e) => setBudget(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="comments">Comments</label>
              <textarea id="comments" rows="4" value={comments} onChange={(e) => setComments(e.target.value)} required />
            </div>
            <div className="form-grp">
              <label htmlFor="full-name">Full Name</label>
              <input type="text" id="full-name" required value={fullname} onChange={(e) => setFullname(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="mobile-no">Mobile No:</label>
              <input type="tel" id="mobile-no" required value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
            </div>
            <div className="form-grp_btn">
              <button 
                type="submit"
                disabled={loading && true}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </section>
        <Footer />
      </main>
    </div>
  )
}

export default Request;
